// Avatar palette — cool teal/blue/purple tones only, similar contrast with white text
const PALETTE = [
  "#009C89", // teal
  "#00777F", // deep teal
  "#1A7894", // steel teal
  "#206A80", // slate teal
  "#2563EB", // blue
  "#3059A3", // medium navy
  "#334D7F", // navy
  "#3D6B9C", // cornflower blue
  "#5D6F9A", // slate blue
  "#6A5B99", // medium purple
  "#5C4EB0", // violet
] as const;

function hashId(id: string): number {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  return hash;
}

export function getPatientAvatarColor(id: string): string {
  return PALETTE[hashId(id) % PALETTE.length] as string;
}
